<template>
  <Transition name="fade" mode="out-in">
    <slot />
  </Transition>
</template>

<script lang="ts">
export default {};
</script>

<style lang="sass"></style>
